import { useWindyMapStore } from "@/stores/windy-map-store";
import { useEffect, useState } from "react";
import geojson from "@/geojson";
import * as L from "leaflet";
import { useParams } from "react-router-dom";
import AlertDialog from "@/components/alert-dialog";

type GeojsonKey = keyof typeof geojson;

const types = {
  home: {
    location: [46.11133, 100.96436],
    regions: [
      "алтай",
      "арвайхээр",
      "баруунурт",
      "баянхонгор",
      "булган",
      "даланзадгад",
      "зуунмод",
      "мандалговь",
      "мөрөн",
      "өлгий",
      "сайншанд",
      "сүхбаатар",
      "тосонцэнгэл",
      "улаангом",
      "улиастай",
      "ховд",
      "цэцэрлэг",
      "чингис",
      "чойбалсан",
      "чойр",
      "хатгал",
      "эрдэнэт",
      "дархан",
      "улаанбаатар",
    ],
  },
  alert: {
    location: [46.11133, 100.96436],
    regions: [
      "алтай",
      "арвайхээр",
      "баруунурт",
      "баянхонгор",
      "булган",
      "даланзадгад",
      "зуунмод",
      "мандалговь",
      "мөрөн",
      "өлгий",
      "сайншанд",
      "сүхбаатар",
      "тосонцэнгэл",
      "улаангом",
      "улиастай",
      "ховд",
      "цэцэрлэг",
      "чингис",
      "чойбалсан",
      "чойр",
      "хатгал",
      "эрдэнэт",
      "дархан",
      "улаанбаатар",
    ],
  },
  region: {
    location: [46.11133, 100.96436],
    regions: ["баруунбүс", "зүүнбүс", "төвийнбүс", "говийнбүс"],
  },
};
const LabelPage: React.FC = () => {
  const { type } = useParams<{
    type: "home" | "region" | "alert";
  }>();
  if (!type || !types[type]) {
    return <></>; // Handle invalid type
  }
  const { location } = types[type];
  const geojsonKeys = types[type].regions as GeojsonKey[];

  const windyLayer = useWindyMapStore((state) => state.layer);
  const windyMap = useWindyMapStore((state) => state.windyMap);
  const [groupLayer, setGroupLayer] = useState<any>();

  useEffect(() => {
    if (!windyLayer) return;

    const newLayer = L.layerGroup().addTo(windyLayer);
    // const newPhenoLayer = L.layerGroup().addTo(layer);

    setGroupLayer(newLayer);
    return () => {
      newLayer.remove();
    };
  }, [windyLayer, type]);
  useEffect(() => {
    if (!groupLayer || !windyMap) return;

    groupLayer.clearLayers();
    geojsonKeys.map((name) => {
      const geoData = geojson[name];
      L.geoJSON(geoData, {
        style: {
          color: "#4D0368",
        },
      }).addTo(groupLayer);
      const { properties } = geoData;
      if (properties && properties.location && properties.name) {
        const [lat, lng] = properties.location;
        L.marker([Number(lat), Number(lng)])
          .addTo(groupLayer)
          .bindPopup(properties.name, {
            closeButton: false,
            autoClose: false,
            closeOnEscapeKey: false,
            closeOnClick: false,
            className: "my-popup text-lg",
          })
          .openPopup();
      }
    });

    windyMap.setView(location, 6);
  }, [groupLayer]);
  if (type == "alert") {
    return <AlertDialog />;
  }
  return <></>;
};

export default LabelPage;
